var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCleanIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2458 2.65455L10.4212 5.53944C10.2331 5.73157 9.97558 5.83985 9.7067 5.83985H9.45971C8.56364 5.83985 8.11985 6.92768 8.76021 7.55448L8.90678 7.69795L9.10559 7.89254C9.73858 8.51212 10.8051 8.06366 10.8051 7.17791V6.91094C10.8051 6.64971 10.9073 6.39885 11.0899 6.21202L13.7881 3.45087L16.2424 0.80839C16.3857 0.654033 16.38 0.413559 16.2295 0.266202C16.0784 0.118338 15.8369 0.118338 15.6858 0.266202L13.2458 2.65455ZM5.69149 7.13983C5.17814 7.49874 5.11736 8.23587 5.56499 8.67402L6.73729 9.82148L7.94522 11.0038C8.38079 11.4302 9.09321 11.371 9.4525 10.8787L9.6171 10.6531C9.90992 10.2518 9.8638 9.69647 9.50881 9.349L8.36441 8.22883L7.19443 7.08364C6.8507 6.74718 6.31613 6.70311 5.92193 6.97871L5.69149 7.13983ZM4.63777 8.8282C4.28537 8.48328 3.73415 8.44671 3.33928 8.74208L1.44241 10.161C0.94856 10.5304 0.903555 11.2544 1.34786 11.6822L3.16631 13.4328L5.00114 15.1991C5.44002 15.6217 6.1515 15.5569 6.50689 15.0621L7.86351 13.1733C8.15162 12.7722 8.10374 12.2208 7.7508 11.8753L6.19492 10.3524L4.63777 8.8282Z",
    fill: "#333333"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCleanIcon);
export default __webpack_public_path__ + "static/media/clean-icon.c8165a9fcd0a318a25f9a5349f39528f.svg";
export { ForwardRef as ReactComponent };